var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid footer pt-5 zIndex22" }, [
      _c("div", { staticClass: "row justify-content-center Medium " }, [
        _c("div", { staticClass: "col-lg-12 center" }, [
          _c("p", [
            _vm._v(
              "\n        Laboratoire Native Italia S.p.A. a socio unico - Largo Augusto, 8 - 20122 Milano -\n        Codice Fiscale, Partita IVA e Registro Imprese di Milano n.\n        11618450156 REA n. MI-1481980 – Tutti i diritti sono riservati"
            ),
            _c("br")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Servizio Clienti disponibile dal Lunedì al Venerdì nei seguenti orari:\n        8.00- 12/ 13 - 17 00.\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n        Numero "),
            _c("a", { attrs: { href: "tel:0290390441" } }, [
              _vm._v("0290390441")
            ]),
            _vm._v(" Oppure manda una mail\n        a:\n        "),
            _c("a", { attrs: { href: "mailto:promozioninative@edps.it" } }, [
              _vm._v("promozioninative@edps.it")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3  text-center" }, [
          _c("p", { staticClass: "center" }, [
            _c(
              "a",
              {
                staticClass: "center",
                attrs: {
                  href: "https://it.lierac.com/cms/note-legali",
                  target: "_blank"
                }
              },
              [_vm._v("Privacy e cookie policy")]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = null
// module chunks = 